/* eslint-disable @typescript-eslint/no-unnecessary-condition */
export default function useExternalRedirect() {
  const handleRedirect = (url: string) => {
    if (window && window.location) {
      return window.location.assign(url);
    }
  };

  return { redirect: handleRedirect };
}
